export const dumpGetCashExchangesData = (data) => {
  return data?.map((item) => ({
    ...item,
    active: item?.active ? true : false,
    status: item?.active ? 'complete' : 'cancel',
  }));
};
